@let filteredProducts = products | filterInfos: store.homeFilterText;
@for (product of filteredProducts | groupProducts; track product.lastRev._id) {
  <o-card-pub-container [lastRev]="product.lastRev" [oldRevs]="product.oldRevs" [showOffline]="true">
  </o-card-pub-container>
} @empty {
  <o-loading [isLoading]="true"></o-loading>
}
